import { Link } from "react-router-dom";
import JobHighlightPills from "./JobHighlightPills";
import { jobPublicHref } from "../lib/jobPublicPath";

const COMPANY_MARK_PALETTE = [
  "nd1-applicant-job-card__mark--green",
  "nd1-applicant-job-card__mark--dark",
  "nd1-applicant-job-card__mark--purple",
  "nd1-applicant-job-card__mark--blue",
];

function companyInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

function companyMarkClass(name) {
  const label = String(name || "").trim();
  if (!label) return COMPANY_MARK_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < label.length; i += 1) {
    hash = (hash + label.charCodeAt(i) * (i + 1)) % COMPANY_MARK_PALETTE.length;
  }
  return COMPANY_MARK_PALETTE[hash];
}

export default function ApplicantHomeJobPreviewCard({ job }) {
  if (!job) return null;

  const company = String(job.company || "").trim();
  const logoUrl = String(job.companyLogoUrl || "").trim();
  const markClass = companyMarkClass(company);
  const summary = String(job.summary || "").trim();

  return (
    <Link to={jobPublicHref(job)} className="nd1-applicant-job-card">
      <div className="nd1-applicant-job-card__head">
        <div className={`nd1-applicant-job-card__mark ${markClass}`}>
          {logoUrl ? (
            <img src={logoUrl} alt="" loading="lazy" />
          ) : (
            <span aria-hidden="true">{companyInitials(company)}</span>
          )}
        </div>
        <div className="nd1-applicant-job-card__info">
          <span className="nd1-applicant-job-card__title">{job.title || "Role"}</span>
          {company ? <span className="nd1-applicant-job-card__company">{company}</span> : null}
        </div>
      </div>
      <JobHighlightPills job={job} variant="applicant-home" />
      {summary ? <p className="nd1-applicant-job-card__summary">{summary}</p> : null}
    </Link>
  );
}
